import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  LISTING_VENUE_OPTIONS,
  ListingVenue,
} from '@/pages/instruments/new-instrument/constants/listing-venues'

export interface VenueFormFieldProps {}

export const VenueFormField: React.FC<VenueFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ venue: ListingVenue }>()

  return (
    <FormField
      name="venue"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Venue Name</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value?.toString()}
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select a venue'}
              setValue={(value) =>
                setValue('venue', value as ListingVenue, { shouldValidate: true })
              }
              options={LISTING_VENUE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
